import hocs from 'common-hocs';
import UserPortal from './userportal.presentation';

//import { push } from 'react-router-redux';

//This container file may be modified for future use

const mapState = () => ({

});

const mapDispatch = {

};

export default hocs({ redux: { mapState, mapDispatch }, i18n: [ 'userportal' ], router: true })(UserPortal);



// WEBPACK FOOTER //
// ./src/userportal/userportal.container.jsx